import { makeStyles } from '@material-ui/styles'

/**
 * Service table styles
 */

export const ImageStyles = makeStyles((theme) => ({
	/** Image visualizer styles */
	imageBlock: {
		color: theme.palette.common.white,
		borderRadius: '.5rem',
		maxWidth: '7rem',
		maxHeight: '7rem',
		display: 'flex',
		alignItems: 'end',
		p: '.5rem',
		justifyContent: 'center',
		flexDirection: 'column'
	},
	image: {
		width: 'auto',
		maxHeight: '6rem',
		maxWidth: '6rem'
	},
	deleteButon: {
		backgroundColor: theme.palette.colors.blue,
		color: theme.palette.common.white,
		marginX: '1rem',
		marginY: '.5rem',
		width: '1.5rem',
		height: '1.5rem'
	},
	/** Img Thumbnail Adder styles */
	container: {
		cursor: 'pointer',
		flex: 1,
		margin: theme.spacing(1),
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		borderRadius: 2,
		backgroundColor: theme.palette.colors.purple,
		color: theme.palette.common.white,
		'&:hover': {
			backgroundColor: theme.palette.colors.purple,
			color: theme.palette.common.white
		},
		'&.Mui-disabled': {
			backgroundColor: theme.palette.colors.purple,
			color: theme.palette.common.white,
			opacity: 0.5
		}
	},
	/** Confirm delete dialog styles */
	btnSaved: {
		backgroundColor: theme.palette.colors.red,
		color: theme.palette.common.white,
		'&:hover': {
			backgroundColor: theme.palette.colors.red,
			color: theme.palette.common.white
		},
		'&.Mui-disabled': {
			backgroundColor: theme.palette.colors.red,
			color: theme.palette.common.white,
			opacity: 0.5
		}
	},
	imageDelete: {
		width: '90%'
	}
}))
